import { Flex, Icon, Text } from '@chakra-ui/react';
import { FaPlane, FaRegClock } from '@tryprospect/ui/icons';

import { ReactComponent as FaBooksSolid } from './icons/books-solid.svg';
import { ReactComponent as FaBrightnessSolid } from './icons/brightness-solid.svg';
import { ReactComponent as FaEarthAmericasReg } from './icons/earth-americas-regular.svg';
import { ReactComponent as FaIslandTropicalSolid } from './icons/island-tropical-solid.svg';

const benefits = [
  {
    description:
      'Enjoy the freedom to work from anywhere in the world. Work from wherever you feel most inspired and productive.',
    icon: FaEarthAmericasReg,
    title: 'Work 100% Remotely',
  },
  {
    description:
      'Enjoy the freedom to set your own work schedule. Outside of our core hours, you’re in full control.',
    icon: FaRegClock,
    title: 'Flex Hours',
  },
  {
    description:
      'Unplug and recharge. We offer 4 weeks paid time off and Canadian holidays so you can disconnect from work.',
    icon: FaIslandTropicalSolid,
    title: 'Generous Time Off',
  },
  {
    description:
      'Breeze through the summer. Enjoy Fridays off in July and August, giving you more time to make the most of your summer.',
    icon: FaBrightnessSolid,
    title: 'Summer Fridays Off',
  },
  {
    description:
      'Your growth is our priority. Enjoy a $1,500 CAD annual allowance to spend on any resources to boost your skills.',
    icon: FaBooksSolid,
    title: 'Learning Allowance',
  },
  {
    description:
      'Take a break, on us. We offer an annual Travel Bonus starting at $1,000 CAD to take the time off you deserve.',
    icon: FaPlane,
    title: 'Travel Bonus',
  },
];

export const Benefits = () => {
  return (
    <>
      {benefits.map((benefit) => {
        return (
          <Flex flexDir="column" key={benefit.title}>
            {benefit.icon && (
              <Icon
                as={benefit.icon}
                bgColor="teal.100"
                borderRadius="10px"
                boxSize="44px"
                color="teal.400"
                fontSize="24px"
                mb="20px"
                px="10px"
              />
            )}
            <Text color="teal.600" fontSize="18px" fontWeight={500}>
              {benefit.title}
            </Text>
            <Text color="gray.700" fontSize="18px" mt="8px" sx={{ textWrap: 'balance' }}>
              {benefit.description}
            </Text>
          </Flex>
        );
      })}
    </>
  );
};
